import {
    supervisorPreflightRequestSchema,
    supervisorPreflightResponseSchema,
    type SupervisorMode,
    type SupervisorPreflightRequest,
} from '@easyflow/shared';

const supervisorCodes: Record<SupervisorMode, string> = {
    listen: '880',
    whisper: '881',
    barge: '882',
};

/** Never INVITE unless this attempt's preflight explicitly authorizes it.
 * Native SIP authorization remains independent and checks authority again.
 */
export async function startSupervisorCall(
    request: SupervisorPreflightRequest,
    preflight: (request: SupervisorPreflightRequest) => Promise<unknown>,
    invite: (number: string) => Promise<boolean>,
): Promise<boolean> {
    const input = supervisorPreflightRequestSchema.parse(request);
    const result = await preflight(input);
    if (!supervisorPreflightResponseSchema.safeParse(result).success) {
        throw new Error('Autorizzazione supervisor negata o risposta preflight non valida');
    }
    return invite(`${supervisorCodes[input.mode]}${input.target_extension}`);
}
